import { render, staticRenderFns } from "./DocumentsSvg.vue?vue&type=template&id=7b7b9c78&"
import script from "./DocumentsSvg.vue?vue&type=script&lang=ts&"
export * from "./DocumentsSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports